export const createQueryStringFromObject = (obj) => {
  if (obj === null || obj === undefined || typeof obj !== 'object') return obj;

  let queryString = '';

  Object.keys(obj).forEach((key) => {
    if (obj[key] === 'null') return;

    const pair = `${key}=${encodeURIComponent(obj[key])}`;
    queryString += queryString ? `&${pair}` : `?${pair}`;
  });

  return queryString;
};
